import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default (props) => {
    const rootRef = React.useRef(null);
    const tooltipRef = React.useRef(null);
    const cleanupRef = React.useRef(null);
    const content = props.html || props.text || '';
    React.useEffect(() => {
        const el = rootRef.current;
        if (!el) {
            return;
        }
        const tooltip = document.createElement('span');
        tooltip.setAttribute('data-tooltip-content', '');
        tooltip.innerHTML = content;
        document.body.appendChild(tooltip);
        tooltipRef.current = tooltip;
        const handleLinkClick = (e) => {
            const target = e.target;
            const link = target.closest('a[data-modal]');
            if (link) {
                e.preventDefault();
                e.stopPropagation();
                const modalId = link.getAttribute('data-modal');
                if (modalId && props.onModalClick) {
                    props.onModalClick(modalId);
                }
                else if (modalId) {
                    const ev = new CustomEvent('tooltip-modal-click', { 'detail': { modalId }, 'bubbles': true });
                    el.dispatchEvent(ev);
                }
            }
        };
        tooltip.addEventListener('click', handleLinkClick);
        let hideTimeout = null;
        let showTimeout = null;
        let mouseX = 0;
        let mouseY = 0;
        const clearHideTimeout = () => {
            if (hideTimeout !== null) {
                clearTimeout(hideTimeout);
                hideTimeout = null;
            }
        };
        const clearShowTimeout = () => {
            if (showTimeout !== null) {
                clearTimeout(showTimeout);
                showTimeout = null;
            }
        };
        const showTooltip = () => {
            clearHideTimeout();
            clearShowTimeout();
            showTimeout = window.setTimeout(() => {
                tooltip.style.display = 'block';
                tooltip.offsetHeight;
                const rect = tooltip.getBoundingClientRect();
                const elRect = el.getBoundingClientRect();
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
                let left = elRect.right + 10;
                let top = elRect.top;
                if (left + rect.width > viewportWidth) {
                    left = elRect.left - rect.width - 10;
                }
                if (top + rect.height > viewportHeight) {
                    top = elRect.bottom - rect.height;
                }
                if (top < 0) {
                    top = elRect.top - rect.height - 5;
                }
                tooltip.style.left = `${left}px`;
                tooltip.style.top = `${top}px`;
                showTimeout = null;
            }, 100);
        };
        const hideTooltip = () => {
            clearHideTimeout();
            hideTimeout = window.setTimeout(() => {
                const tooltipRect = tooltip.getBoundingClientRect();
                const elRect = el.getBoundingClientRect();
                const overTooltip = mouseX >= tooltipRect.left && mouseX <= tooltipRect.right && mouseY >= tooltipRect.top && mouseY <= tooltipRect.bottom;
                const overTrigger = mouseX >= elRect.left && mouseX <= elRect.right && mouseY >= elRect.top && mouseY <= elRect.bottom;
                if (!overTooltip && !overTrigger) {
                    tooltip.style.display = 'none';
                }
                hideTimeout = null;
            }, 200);
        };
        const trackMouse = (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
        };
        document.addEventListener('mousemove', trackMouse);
        tooltip.addEventListener('mouseenter', () => {
            clearHideTimeout();
            tooltip.style.display = 'block';
        });
        tooltip.addEventListener('mouseleave', hideTooltip);
        tooltip.addEventListener('click', (e) => e.stopPropagation());
        el.addEventListener('mouseenter', showTooltip);
        el.addEventListener('mouseleave', hideTooltip);
        cleanupRef.current = () => {
            document.removeEventListener('mousemove', trackMouse);
            clearHideTimeout();
            clearShowTimeout();
            tooltip.removeEventListener('click', handleLinkClick);
            tooltip.remove();
            tooltipRef.current = null;
        };
        return cleanupRef.current;
    }, []);
    React.useEffect(() => {
        if (tooltipRef.current) {
            tooltipRef.current.innerHTML = content;
        }
    }, [content]);
    return _jsx("span", { ref: rootRef, className: props.className, style: props.style, children: props.children });
};
